import { performGetRequest } from '@atlassian/jira-fetch';
import type { BoardFeatureResponse } from '../../common/types';
import { getBoardFeaturesUrl } from '../utils';

export const getBoardFeatures = async (boardId: number) => {
	const data = await performGetRequest<BoardFeatureResponse>(getBoardFeaturesUrl(boardId));
	return data.features;
};
